import * as React from "react";
import * as ReactDOM from "react-dom";
import * as _ from "lodash";
import {connect} from "react-redux";
import {IScreenComponentProps, screenComponent} from "../screenComponent";
import {showMainMenu} from "../../../store/actions/screens";

interface Props extends IScreenComponentProps
{
    showMainMenu: () => void;
}

import './Leaderboard.scss';

class Leaderboard extends React.Component<Props, null>
{
    constructor(public props: Props)
    {
        super(props);
    }


    getTableContents = () =>
    {
        return _.times(50, i =>
        {
            const name: string = 'Name';
            const score: number = _.random(500, 10000);

            return <tr
                        styleName={'score-row'}
                        key={i}>

                <td>{this.getMedal(i)}</td>
                <td>{i}</td>
                <td>{name}</td>
                <td>{score}</td>

            </tr>
        });
    };


    getMedal = (position: number) : JSX.Element =>
    {
        switch (position)
        {
            case 0:

                return <div styleName={'gold-medal'}>gold</div>;

            case 1:

                return <div styleName={'silver-medal'}>silver</div>;

            case 2:

                return <div styleName={'bronze-medal'}>bronze</div>;
        }
    };


    /**
     * render the component
     * @returns {JSX.Element}
     */
    render() : JSX.Element
    {
        if (! this.props.active) return null;

        return <div styleName={'leaderboard'}>

            <button styleName={'back-button'}
                    onClick={this.props.showMainMenu}>back</button>

            <div styleName={'content'}>

                <h2 styleName={'title'}>leaderboard</h2>

                <table styleName={'table'}>

                    <tbody>

                        <tr styleName={'header-row'}>
                            <th>medal</th>
                            <th>position</th>
                            <th>name</th>
                            <th>score</th>
                        </tr>

                        {this.getTableContents()}

                    </tbody>

                </table>

            </div>

        </div>
    }
}


/**
 * map the state to props
 * @param state
 */
const mapStateToProps = state =>
{
    return {}
};


/**
 * map dispatch functions to the component props
 * @param dispatch
 * @returns {{onModeSelect: ((mode: string) => any); onCountrySelect: ((country: string) => any)}}
 */
const mapDispatchToProps = dispatch =>
{
    return {
        showMainMenu: () => dispatch(showMainMenu())
    }
};

export default screenComponent()(connect(mapStateToProps, mapDispatchToProps)(Leaderboard));



// WEBPACK FOOTER //
// ./src/ts/app/screens/leaderboard/Leaderboard.tsx